import { render, staticRenderFns } from "./SidebarDropdownItem.vue?vue&type=template&id=3c622a1e&"
import script from "./SidebarDropdownItem.vue?vue&type=script&lang=js&"
export * from "./SidebarDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports